<template>
    <div>
        <div class='searchBox' style="margin-bottom:10px">
            <el-form :inline="true" :model="searchForm" ref="searchForm">
                <el-form-item label="标段编号" prop='bdbh'>
                    <el-input v-model="searchForm.bdbh"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="search">查询</el-button>
                    <el-button type="primary" @click="resetForm('searchForm')">重置</el-button>
                </el-form-item>
            </el-form>
        </div>
        <el-table
            ref="table"
            border
            :data="tableData"
            style="width: 100%"
        >
            <el-table-column type="index" label="序号" width="60">
                <template slot-scope="scope">{{(currentPage - 1) * pageSize + scope.$index + 1}}</template>
            </el-table-column>
            <el-table-column prop="bdbh" label="标段编号"  min-width="160" show-overflow-tooltip></el-table-column>
            <el-table-column prop="bdmc" label="标段名称"  min-width="160" show-overflow-tooltip></el-table-column>
            <el-table-column prop="zbr" label="招标人"  min-width="160" show-overflow-tooltip></el-table-column>
            <el-table-column prop="kbsj" label="开标时间" width="160" show-overflow-tooltip></el-table-column>
            <el-table-column prop="ztx" label="状态" width="120" show-overflow-tooltip></el-table-column>
            <el-table-column  label="操作" width="60" fixed='right'>
                <template slot-scope="scope">
                    <el-button type="text"  @click='edit(scope.row)'>编辑</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="clear">
            <span class="lf pageNum">共{{total}}条。</span>
            <myPage
            class="rt"
            :total="total"
            :page-size="pageSize"
            :currentPage="currentPage"
            @changePage="changePage"
            ></myPage>
        </div>
        <!-- 新增编辑 -->
        <el-dialog title='编辑开标项目' :visible.sync="dialogVisible" width='760px' lock-scroll :close-on-click-modal="false">
            <el-form :model="form" ref="form" label-width="140px" :rules="formRules">
                <el-form-item label="标段编号" prop='bdbh'>
                    <el-input v-model="form.bdbh" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="标段名称" prop='bdmc'>
                    <el-input v-model="form.bdmc" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="招标人" prop='zbr'>
                    <el-input v-model="form.zbr" :disabled="true"></el-input>
                </el-form-item>
                <el-row>
                    <el-col :span='12'>
                        <el-form-item label="投标递交截止时间"  prop='tbjzsj'>
                            <el-date-picker
                            v-model="form.tbjzsj"
                            type="datetime"
                            value-format='yyyy-MM-dd HH:mm:ss'
                            placeholder="选择日期时间">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span='12'>
                        <el-form-item label="开标时间" prop='kbsj'>
                            <el-date-picker
                            v-model="form.kbsj"
                            type="datetime"
                            value-format='yyyy-MM-dd HH:mm:ss'
                            placeholder="选择日期时间">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div class='btnBox'>
                <el-button type="primary" @click='saveForm("form")'>确定</el-button>
                <el-button type="primary" @click='cancelForm("form")'>取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import myPage from '../../components/page'
export default {
    name:'',
    components:{
        myPage
    },
    props:[
        'adminLx'
    ],
    data(){
        return{
            searchForm:{
                bdbh:'',
            },
            tableData:[],
            total:0,
            pageSize:10,
            currentPage:1,
            multipleSelection:[],
            dialogVisible:false,
            form:{

            },
            formRules:{
                tbjzsj:[{required:true,trigger:'change',message:'必填项'}],
                kbsj:[{required:true,trigger:'change',message:'必填项'}],
            }
        }
    },
    methods:{
        getData(){
            let para=this.searchForm;
            para.currentPage=this.currentPage;
            para.pageSize=this.pageSize;
            para.lx=this.adminLx
            this.$api.getKbsz(para).then(res=>{
                if(res.data.meta.success){
                    this.tableData=res.data.data.list;
                    this.total=res.data.data.total
                }
            }).catch(()=>{})
        },
        search(){
            this.currentPage=1;
            this.getData();
        },
        //编辑
        edit(row){
            this.dialogVisible=true;
            this.form=Object.assign({},row)
        },
        saveForm(formName){
            this.$refs[formName].validate((valid)=>{
                if(valid){
                    let para={
                        id:this.form.id,
                        lx:this.adminLx,
                        kbsj:this.form.kbsj,
                        tbjzsj:this.form.tbjzsj

                    };
                    this.$api.saveKbsz(para).then(res=>{
                        if(res.data.meta.success){
                            this.$message({
                                type:'success',
                                message:'保存成功！'
                            })
                            this.dialogVisible=false;
                            this.getData();
                        }else{
                            this.$message({
                                type:'error',
                                message:res.data.meta.message
                            })
                        }
                    }).catch(()=>{})
                }else{
                    return false;
                }
            })
        },
        cancelForm(formName){
            this.$refs[formName].resetFields();
            this.dialogVisible=false
        },
        //重置
        resetForm(formName){
            this.$refs[formName].resetFields();
        },
        changePage(val){
            this.currentPage=val;
            this.getData();
        },
    },
    mounted(){
        this.getData();
    }
}
</script>  
<style lang="less" scoped>

</style>